import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-analysis",
  "use": "icon-analysis-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-analysis\"><path d=\"M836.4 848.8l-349.2-324V50.1h1l-0.5-0.5C225 49.6 12 262.6 12 525.3S225 1001 487.7 1001c137.8 0 261.8-58.6 348.7-152.2z\" p-id=\"3811\" /><path d=\"M538.6 25h-1v474.7l349.7 324.4c78.8-84.9 126.9-198.6 126.9-323.5C1014.3 238 801.3 25 538.6 25z\" p-id=\"3812\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol